import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { BorderGradient, Tabs, Actions, Helper } from 'Components';
import './InvoicesDesktopHeader.css';

const InvoicesDesktopHeader = props => (
  <div className="invoices-desktop-header">
    {!props.showNoInformationFound &&
    <div className="invoices-desktop-header__bar">
      <Helper text={i18n.t('tutorials:common.ExportToExcel')}>
        <Actions.ExportToExcel onClick={props.downloadInvoices} />
      </Helper>
    </div>
    }
    <BorderGradient />
    <div className="invoices-desktop-header__tabs">
      <Helper text={i18n.t('tutorials:invoices.4')}>
        <Tabs
          onClick={props.onTabsChange}
          tabs={props.tabs}
          labels={props.tabs.map(tab => i18n.t(`invoices:${tab}`))}
          index={props.tabIndex}
          className="tabs__button"
        />
      </Helper>
      <div className="invoices-desktop-header__results__dropdown">
        <Actions.ResultsPerPage
          value={props.pageSize}
          onChange={props.onPageSizeChange}
        />
      </div>
    </div>
  </div>
);

InvoicesDesktopHeader.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.string),
  tabIndex: PropTypes.number,
  onTabsChange: PropTypes.func,
  pageSize: PropTypes.number,
  onPageSizeChange: PropTypes.func,
  showNoInformationFound: PropTypes.bool,
  downloadInvoices: PropTypes.func,
};

export default InvoicesDesktopHeader;



// WEBPACK FOOTER //
// ./src/containers/Invoices/InvoicesList/InvoicesListHeader/InvoicesDesktopHeader/InvoicesDesktopHeader.jsx